import React, { Fragment, Component } from "react";
import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  UncontrolledButtonDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import {
  faAngleDown,
  faUser,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import chatbot from "../../../assets/utils/images/avatars/chatbot.png";
import { properties } from "../../../constants/Propertise";
import Confirmation from "../../../Pages/Confirmation";
import Overlay from "../../../Pages/Overlay";
import { history } from "../../../history";
import { api } from "../../../api/api";
import Theme from "../../../Pages/Theme";
import AlertMessages from "../../../Pages/AlertMessages";
import {
  themeConst,
  userSessionTimeOutConfig,
  allowGlobalSerachModules,
} from "../../../constants/themeConfig";
import { ClearLocalStorage } from "../../../config/ClearLocalStorage";
import { connect } from "react-redux";
import {
  setBackgroundColorRevise,
  setHeaderBackgroundColourRevise,
} from "../../../Reducers/ThemeOptions";

class UserBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      show: false,
      showCreateModel: false,
      showAlertModel: false,
      hasError: false,
      isPending: true,
      isSucess: false,
      message: "",
      showLogWarning: false,
      showUpdateProfileModel: false,
      showThemeModel: false,
      // warningTime: 10000 * 1350,
      // signoutTime: 10000 * 1440

      warningTime: 43200 * 1000, // 12hours converted to milliseconds
      signoutTime: 44100 * 1000, // 12hours 15minutes converted to milliseconds
    };

    if (ClearLocalStorage.clearStorage() === true) {
      history.push(`${process.env.PUBLIC_URL}/login`);
    }
    // if (ClearLocalStorage.clearStorage()== true) {
    //     window.location.href = `${process.env.PUBLIC_URL}/login`;
    //   }


    this.events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];

    this.warn = this.warn.bind(this);
    this.resetTimeout = this.resetTimeout.bind(this);

    for (var i in this.events) {
      window.addEventListener(this.events[i], this.resetTimeout);
    }

    this.setTimeout();

    let pageName = window.location.pathname.trim().split("/");
    if (
      pageName.includes("updateIncident") === true &&
      localStorage.getItem("lockedIncidentId") !== null &&
      localStorage.getItem("lockedIncidentId") !== ""
    ) {
      this.unlockedIncident();
    }
  }

  clearTimeoutFunc = () => {
    if (this.warnTimeout) clearTimeout(this.warnTimeout);

    if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
  };

  setTimeout = () => {
    if (
      localStorage.getItem("onevubasicauthtoken") !== null &&
      localStorage.getItem("onevubasicauthtoken") !== undefined &&
      localStorage.getItem("onevubasicauthtoken") !== ""
    ) {
      this.warnTimeout = setTimeout(this.warn, this.state.warningTime);
      this.logoutTimeout = setTimeout(this.logoff, this.state.signoutTime);
    }
  };

  resetTimeout = () => {
    this.clearTimeoutFunc();
    this.setTimeout();
  };

  warn = () => {
    this.setState({
      showLogWarning: true,
    });
  };

  componentDidMount() {}

  handleCloseLogWaning = () => {
    this.setState({ showLogWarning: false });
  };

  closeAlertModel = () => {
    this.setState({
      showAlertModel: false,
    });
  };

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  openLogOutConfirmation = () => {
    this.setState({
      show: true,
    });
  };

  logoff = () => {
    this.setState(
      { open: false, authDone: false, isLoginSuccess: false },
      () => {
        history.push(`${process.env.PUBLIC_URL}/login`);
        localStorage.clear();
        sessionStorage.clear();
      }
    );
  };

  componentWillUnmount() {
    this.warnTimeout = setTimeout(this.warn, this.state.warningTime);
    this.logoutTimeout = setTimeout(this.logoff, this.state.signoutTime);
  }

  closeAddModel = () => {
    this.setState({
      showCreateModel: false,
    });
  };

  showThemePopUp = () => {
    this.setState({
      showThemeModel: true,
    });
  };

  themeHandler = (id, headerTheme, sidebarTheme) => {
    let userPreferencesBody;
    if (id !== null) {
      userPreferencesBody = {
        id: id,
        username: localStorage.getItem("onevuusername"),
        headerTheme: headerTheme,
        sidebarTheme: sidebarTheme,
      };
    } else {
      userPreferencesBody = {
        username: localStorage.getItem("onevuusername"),
        headerTheme: headerTheme,
        sidebarTheme: sidebarTheme,
      };
    }
    return userPreferencesBody;
  };

  closeThemeModel = () => {
    this.setState({
      showThemeModel: false,
    });

    let userPreferencesThemeUrl = `${process.env.REACT_APP_USERMANAGEMENT_API_URL}userPreferences`;
    let userPreferencesBody = this.themeHandler(
      localStorage.getItem("id"),
      localStorage.getItem("oneviewheaderTheme"),
      localStorage.getItem("oneviewsiderbarTheme")
    );
    api
      .post(userPreferencesThemeUrl, userPreferencesBody)
      .then((result) => {
        if (result.status === 200) {
          localStorage.setItem("oneviewheaderTheme", result.data.headerTheme);
          localStorage.setItem(
            "oneviewsiderbarTheme",
            result.data.sidebarTheme
          );
          this.props.setHeaderBackgroundColourRevise(result.data.headerTheme);
          this.props.setBackgroundColorRevise(result.data.sidebarTheme);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  showChatbot = () => {
    history.push(`${process.env.PUBLIC_URL}/aichatbot`);
  };

  render() {
    let username = localStorage.getItem("onevuusername");

    return (
      <Fragment>
        <Confirmation
          openOverlay={this.state.showLogWarning}
          closeOverlay={this.handleCloseLogWaning}
          confirmationMessage={`${
            properties.loggedOutWarningMessage +
            properties.timeMilliSeconds +
            properties.loggedOutWarningMessageNext
          }`}
          cancelButtonText={properties.NoText}
          okButtonText={properties.YesText}
          okAction={this.handleCloseLogWaning}
          cancelAction={this.logoff}
        />

        <Confirmation
          openOverlay={this.state.show}
          closeOverlay={this.handleClose}
          confirmationMessage={properties.logOutConfirmationMessage}
          cancelButtonText={properties.cancelButtonText}
          okButtonText={properties.okText}
          okAction={this.logoff}
          cancelAction={this.handleClose}
        />

        <Overlay
          title={properties.themeText}
          openOverlay={this.state.showThemeModel}
          closeOverlay={this.closeThemeModel}
          className="completemodal"
        >
          <Theme />
        </Overlay>

        <Overlay
          openOverlay={this.state.showAlertModel}
          closeOverlay={this.closeAlertModel}
          className="alertData"
        >
          <AlertMessages
            isSucess={this.state.isSucess}
            isPending={this.state.isPending}
            apiError={this.state.hasError}
            showAlert={this.state.showAlertModel}
            closeAlert={this.closeAlertModel}
            message={this.state.message}
          />
        </Overlay>

        <div className="header-btn-lg pr-0">
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="widget-content-left">
                <img
                  width={38}
                  // className="rounded-circle"
                  src={chatbot}
                  alt=""
                  onClick={this.showChatbot}
                  style={{ cursor: "pointer" }}
                  title="Neo Gen-AI"
                />
                <UncontrolledButtonDropdown>
                  <DropdownToggle
                    color="link"
                    className="p-0 d-flex align-items-center"
                  >
                    <FontAwesomeIcon
                      className="ml-2 opacity-8 fa-2x"
                      icon={faUserCircle}
                      id="username"
                    />
                    <UncontrolledTooltip
                      style={{ maxWidth: "100%" }}
                      placement="left"
                      target="username"
                    >
                      &nbsp;{`User: ${username}`}&nbsp;
                    </UncontrolledTooltip>
                    <FontAwesomeIcon
                      className="ml-2 opacity-8"
                      icon={faAngleDown}
                    />
                  </DropdownToggle>
                  <DropdownMenu right className="rm-pointers dropdown-menu-lg">
                    <Nav vertical>
                      <ul className="nav flex-column">
                        <li className="nav-item" onClick={this.showThemePopUp}>
                          <span className="nav-link">
                            <i className="nav-link-icon pe-7s-settings"></i>
                            <span>{properties.themeText}</span>
                          </span>
                        </li>
                        <li
                          className="nav-item"
                          onClick={this.openLogOutConfirmation}
                        >
                          <span className="nav-link">
                            <i className="nav-link-icon pe-7s-switch"></i>
                            <span>{properties.logOutButtonText}</span>
                          </span>
                        </li>
                      </ul>
                    </Nav>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
              {/*<div className="widget-content-left  ml-3 header-user-info">
                <div className="widget-heading">
                  {localStorage.getItem("loggedInUserFullName")}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setHeaderBackgroundColourRevise: (headerTheme) =>
      dispatch(setHeaderBackgroundColourRevise(headerTheme)),
    setBackgroundColorRevise: (siderbarTheme) =>
      dispatch(setBackgroundColorRevise(siderbarTheme)),
  };
};

export default connect(null, mapDispatchToProps)(UserBox);
